import { createClass as _createClass, createForOfIteratorHelper as _createForOfIteratorHelper, inherits as _inherits, classCallCheck as _classCallCheck, callSuper as _callSuper, wrapNativeSuper as _wrapNativeSuper } from '../../_virtual/_rollupPluginBabelHelpers.js';

var CancelError = /*#__PURE__*/function (_Error) {
  function CancelError(reason) {
    var _this;
    _classCallCheck(this, CancelError);
    _this = _callSuper(this, CancelError, [reason || 'Promise was canceled']);
    _this.name = 'CancelError';
    return _this;
  }
  _inherits(CancelError, _Error);
  return _createClass(CancelError, [{
    key: "isCanceled",
    get: function get() {
      return true;
    }
  }]);
}(/*#__PURE__*/_wrapNativeSuper(Error));
var PCancelable = /*#__PURE__*/function () {
  function PCancelable(executor) {
    var _this2 = this;
    _classCallCheck(this, PCancelable);
    this._cancelHandlers = [];
    this._isPending = true;
    this._isCanceled = false;
    this._rejectOnCancel = true;
    this._promise = new Promise(function (resolve, reject) {
      _this2._reject = reject;
      var onResolve = function onResolve(value) {
        if (!_this2._isCanceled || !onCancel.shouldReject) {
          _this2._isPending = false;
          resolve(value);
        }
      };
      var onReject = function onReject(error) {
        _this2._isPending = false;
        reject(error);
      };
      var onCancel = function onCancel(handler) {
        if (!_this2._isPending) {
          throw new Error('The `onCancel` handler was attached after the promise settled.');
        }
        _this2._cancelHandlers.push(handler);
      };
      Object.defineProperties(onCancel, {
        shouldReject: {
          get: function get() {
            return _this2._rejectOnCancel;
          },
          set: function set(_boolean) {
            _this2._rejectOnCancel = _boolean;
          }
        }
      });
      return executor(onResolve, onReject, onCancel);
    });
  }
  return _createClass(PCancelable, [{
    key: "then",
    value: function then(onFulfilled, onRejected) {
      // eslint-disable-next-line promise/prefer-await-to-then
      return this._promise.then(onFulfilled, onRejected);
    }
  }, {
    key: "catch",
    value: function _catch(onRejected) {
      return this._promise["catch"](onRejected);
    }
  }, {
    key: "finally",
    value: function _finally(onFinally) {
      return this._promise["finally"](onFinally);
    }
  }, {
    key: "cancel",
    value: function cancel(reason) {
      if (!this._isPending || this._isCanceled) {
        return;
      }
      this._isCanceled = true;
      if (this._cancelHandlers.length > 0) {
        try {
          var _iterator = _createForOfIteratorHelper(this._cancelHandlers),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var handler = _step.value;
              handler();
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
        } catch (error) {
          this._reject(error);
          return;
        }
      }
      if (this._rejectOnCancel) {
        this._reject(new CancelError(reason));
      }
    }
  }, {
    key: "isCanceled",
    get: function get() {
      return this._isCanceled;
    }
  }], [{
    key: "fn",
    value: function fn(userFn) {
      return function () {
        for (var _len = arguments.length, arguments_ = new Array(_len), _key = 0; _key < _len; _key++) {
          arguments_[_key] = arguments[_key];
        }
        return new PCancelable(function (resolve, reject, onCancel) {
          arguments_.push(onCancel);
          // eslint-disable-next-line promise/prefer-await-to-then
          userFn.apply(void 0, arguments_).then(resolve, reject);
        });
      };
    }
  }]);
}();
Object.setPrototypeOf(PCancelable.prototype, Promise.prototype);
var pCancelable = PCancelable;
var CancelError_1 = CancelError;
pCancelable.CancelError = CancelError_1;

export default pCancelable;
export { CancelError_1 as CancelError, pCancelable as __moduleExports };
